import request from "@/utils/request";

// 税种
export function getTaxListTypeFun(data) {
  return request({
    url: `/fmsapi/common/GetTaxListType`,
    method: "post",
    data,
  });
}


export function getSignatureInfoFun(data) {
  return request({
    url: `/fmsapi/common/GetSignatureInfo`,
    method: "post",
    data,
  });
}
export function updateIncomeRecord(data) {
  return request({
    url: `/fmsapi/IERecord/UpdateIncomeRecord`,
    method: "post",
    data,
  });
}
